import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

export const AccordianComponent = ({ children, eventKey, headerContent }) => {
	return (
		<Accordion defaultActiveKey="0">
			<Accordion.Item eventKey={eventKey}>
				<Accordion.Header>
					<div className="w-100">
						{headerContent}
					</div>
				</Accordion.Header>
				<Accordion.Body>
					{children}
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
};